import styles from './TeamRecoveryView.module.scss';

/**
 * Legenda fasce RI (Recovery Index): condivisa tra `TeamRecoveryView` (vista
 * Recovery) e `TeamEffortRecoveryView` (vista combinata Sforzo + Recovery),
 * prima duplicata verbatim nei due componenti.
 */
export function RiLegend() {
  return (
    <div className={styles.legend}>
      <span className={`${styles.legendDot} ${styles.riCritical}`} /> Critico
      <span className={`${styles.legendDot} ${styles.riWarning}`} /> Attenzione
      <span className={`${styles.legendDot} ${styles.riNormal}`} /> Normale
      <span className={`${styles.legendDot} ${styles.riGood}`} /> Ottimo
    </div>
  );
}

export default RiLegend;
